import { render, staticRenderFns } from "./VideoTwitch.vue?vue&type=template&id=3dd4f92e&scoped=true"
import script from "./VideoTwitch.vue?vue&type=script&lang=js"
export * from "./VideoTwitch.vue?vue&type=script&lang=js"
import style0 from "./VideoTwitch.vue?vue&type=style&index=0&id=3dd4f92e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd4f92e",
  null
  
)

export default component.exports